module.exports = __webpack_public_path__ + "static/img/M5.db40c352.png";